/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Modal, Table, } from 'semantic-ui-react';
import Axios from 'axios';
import moment from 'moment';

import APP_CONSTANTS from '../../../../../config/constants';


const BillPaymentDetailsModal = ({ handleCloseEdit, billData, ...props }) => {

    const [billPaymentsData, setBillPaymentsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        console.log("billData", billData)
        const billPaymentHeaderData = {
            customerNo: localStorage.getItem('customerNumber'),
            userId: localStorage.getItem('userId'),
            billReferenceNo: billData.billReferenceNo
        }

        Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/payment/getBillsPayment`, billPaymentHeaderData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('isloggedIn')
            }
        }).then((response => {
            setBillPaymentsData(response.data.data)
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)
    }, [])

    return (
        <>
            <Modal.Content>
                <Table size="large" className="w3-medium">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell className="w3-white" colSpan="8">Bills Payment Details</Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell className="labelName p-bold-600">Payment Date</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Payment Reference No.</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {billPaymentsData && billPaymentsData.map((object, index) => {
                            return (
                                <Table.Row verticalAlign='middle' key={index}>
                                    <React.Fragment>
                                        <Table.Cell>{moment(object.paymentDate).format('DD-MM-YYYY')}</Table.Cell>
                                        <Table.Cell>{object.paymentReferenceNo}</Table.Cell>
                                        <Table.Cell>{object.paidAmount}</Table.Cell>
                                    </React.Fragment>
                                </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table>
            </Modal.Content>
        </>
    )
}


export default BillPaymentDetailsModal
